import { getApiBase } from "./apiBase";
import { dropSession, isAuthError } from "./session";

/**
 * Запрос к разделу документов. Все эндпоинты — POST с JSON-телом и Bearer-токеном,
 * как остальные вызовы cpai к API.
 */
const request = async (action, body = {}) => {
  const base = getApiBase();
  if (!base) {
    throw new Error("Не задан REACT_APP_FW_API для запросов к API.");
  }

  const token = localStorage.getItem("token");
  const headers = { "Content-Type": "application/json" };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(`${base}/v1/document/${action}`, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  });

  const data = await res.json().catch(() => ({}));

  if (isAuthError(res.status, data && data.message)) {
    dropSession();
    const error = new Error("Сессия истекла. Войдите в кабинет заново.");
    error.status = res.status;
    throw error;
  }

  if (!res.ok) {
    const error = new Error(
      data && data.message ? data.message : `Ошибка запроса (код ${res.status}).`
    );
    error.status = res.status;
    error.errors = data && data.errors ? data.errors : null;
    error.payload = data;
    throw error;
  }

  return data;
};

export const fetchTemplates = (companyId) =>
  request("template-list", companyId ? { company_id: companyId } : {});

export const fetchRequisites = (companyId) =>
  request("requisites", companyId ? { company_id: companyId } : {});

export const saveRequisites = (values, companyId) =>
  request("requisites-save", companyId ? { ...values, company_id: companyId } : values);

export const fetchDocuments = (companyId) =>
  request("list", companyId ? { company_id: companyId } : {});

export const previewDocument = (code, params, companyId) =>
  request("preview", { code, params, ...(companyId ? { company_id: companyId } : {}) });

export const signDocument = (code, params, companyId) =>
  request("sign", {
    code,
    params,
    accepted: true,
    ...(companyId ? { company_id: companyId } : {}),
  });

export const viewDocument = (id) => request("view", { id });

/**
 * PDF нельзя открыть обычной ссылкой: заголовок Authorization браузер по ней
 * не отправит. Забираем файл запросом и отдаём как blob.
 */
export const downloadDocument = async (id, fileName) => {
  const base = getApiBase();
  if (!base) {
    throw new Error("Не задан REACT_APP_FW_API для запросов к API.");
  }

  const token = localStorage.getItem("token");
  const headers = { "Content-Type": "application/json" };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(`${base}/v1/document/download`, {
    method: "POST",
    headers,
    body: JSON.stringify({ id }),
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(
      data && data.message ? data.message : `Не удалось скачать документ (код ${res.status}).`
    );
  }

  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName || `document-${id}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
